import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import logo  from "../../assets/images/site-logo.png"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { withTranslation } from "react-i18next"
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import Moment from 'react-moment';
import axios from "axios";
import { PublicHeader, PublicFooter, AgentCard, CalendarIcon, PlaceIcon } from "../../components/PublicLead";
import PhoneInputField from "components/Common/PhoneInput";
import { Label, FormGroup, Card, CardBody,  Container, Row, Col, Alert } from "reactstrap";
class ProjectInviteUser extends Component {
    constructor(props) {
        super(props)
        this.state = {
            invitedata:'',
            timeOptions: [],
            formVisible: true,
            thankYouMessage: '',
            projectdata:''
        }    
      }
      formatTime = (date) => {
        let hours = date.getHours();
        let minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        const timeString = `${hours}:${minutes} ${ampm}`;
        return timeString;
      }
       formatPhoneNumber(phone) {
    if (!phone) return '';
    const cleaned = ('' + phone).replace(/\D/g, '');
    const lastTen = cleaned.slice(-10);
    const match = lastTen.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return phone;
  }
      componentDidMount() {
        const { match: { params } } = this.props;
        if (params && params.projectEventInviteId) {
            const inviteId = params.projectEventInviteId;
            axios.get(`https://rscoreapi.azurewebsites.net/api/ProjectEventInvite/id/${inviteId}`, {
              headers: {
                //'Authorization': str,
                'Content-Type': 'application/json'
              }
            })
            .then(res => {
                const invitedata = res.data;
                this.setState({ invitedata }, () => {
                  const campaignProjectId = this.state.invitedata.projectGuid;
                  axios.get(`https://rscoreapi.azurewebsites.net/api/ProjectExt/guid?projectid=${campaignProjectId}`)
                  .then(response => {
                    const projectdata = response.data;
                    this.setState({ projectdata });
                    //console.log(projectdata); // Log the second API response
                  })
                  .catch(error => {
                    console.error("There was an error fetching the second data!", error);
                  });
              
                });
                this.setState({ invitedata, loading: false }, () => {
                  if (this.state.invitedata && this.state.invitedata.eventStartTime) {
                    const eventStartTime = this.state.invitedata.eventStartTime; 
                    const eventEndTime = this.state.invitedata.eventEndTime;
                    
                                const timeOptions = [];
                                let currentTime = new Date(`01/01/2000 ${eventStartTime}`);
                                const endTime = new Date(`01/01/2000 ${eventEndTime}`);
                                endTime.setHours(endTime.getHours() - 1);
                            
                                while (currentTime <= endTime) {
                                  const formattedStartTime = this.formatTime(currentTime);
                                  const nextHour = new Date(currentTime);
                                  nextHour.setHours(nextHour.getHours() + 1);
                                  const formattedEndTime = this.formatTime(nextHour);
                                  timeOptions.push(`${formattedStartTime}-${formattedEndTime}`);
                                  currentTime.setHours(currentTime.getHours() + 1);
                                }
                            
                                this.setState({
                                eventStartTime,
                                eventEndTime,
                                timeOptions,
                        });
                  }
                });
              })
            .catch(error => {
              this.setState({ error, loading: false });
            });
        
        } else {
          this.setState({ error: 'Invalid invite ID', loading: false });
        }
      }


      handleSubmit = (values, { setSubmitting }) => {
        const updateFeature = {
          projectEventInviteGuId: values.projectEventInviteGuId,
          projectEventInviteId: parseInt(values.id),
          projectId: values.projectId,
          projectName: values.projectName,
          name: values.name,
          phoneNo: values.phoneNo,
          email:values.email,
          eventSlot:values.eventSlot,
          agentId: parseInt(this.state.projectdata.agentId),
          isRealator: (values.isRealator=="true") ? true : false,
      };
     
      toast.loading("Please wait...");
      axios.post('https://rscoreapi.azurewebsites.net/api/ProjectEventInviteRegistration', updateFeature, {
        headers: {
          'Content-Type': 'application/json',
          //'Authorization': str
        }
      })
    .then(response => {
      toast.dismiss();
      
      if(response.data.success){
        toast.success("Saved successfully!");
        this.setState({
          formVisible: false,
          thankYouMessage:`We would like to thank you for your inquiry. We will be in touch with you very soon!`,
        });
      }else{
        response.data.validationErrors.forEach(error => {
          toast.error(error);
        });
      }
     
    })
    .catch(error => {
      console.error(error);
     
    });
      } 

    render() {
        const { timeOptions, invitedata, projectdata } = this.state;
        const { formVisible, thankYouMessage } = this.state;
        const isEventDateTodayOrFuture = new Date(invitedata.eventDate) >= new Date().setHours(0, 0, 0, 0);
        
        return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />
      <MetaTags>
            <title>Upcoming Events | Realty Space</title>
          </MetaTags>
          {this.state.projectdata.isActive && isEventDateTodayOrFuture ? ( 
        <div className="rs-page">
          <PublicHeader logoSrc={projectdata?.agent?.logoFilePath || logo} />
          <div className="rs-main">
            <div className="rs-col">
              <div className="rs-navy rs-curve">
                <div className="rs-badge">{invitedata.eventType === 1 ? "In-person" : "Online"}</div>
                <h1>{invitedata.projectName || projectdata?.projectName}</h1>
                {invitedata.eventNotes ? <p className="rs-muted">{invitedata.eventNotes}</p> : null}
                <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 4 }}>
                  <div className="rs-meta-row">
                    <div className="rs-icon-sq"><CalendarIcon /></div>
                    <div>
                      <Moment format="dddd, MMMM D, YYYY">{invitedata.eventDate}</Moment>
                      {invitedata.eventStartTime ? ` · ${invitedata.eventStartTime}` : ""}
                      {invitedata.eventEndTime ? `–${invitedata.eventEndTime}` : ""}
                    </div>
                  </div>
                  {invitedata.address ? (
                    <div className="rs-meta-row">
                      <div className="rs-icon-sq"><PlaceIcon /></div>
                      <a href={`https://maps.google.com/?q=${encodeURIComponent(invitedata.address)}`} target="_blank" rel="noreferrer" style={{ color: "#fff", fontSize: 15 }}>
                        {invitedata.address}
                      </a>
                    </div>
                  ) : null}
                </div>
                <div className="rs-note">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#F5B83D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: "none", marginTop: 2 }}><circle cx="12" cy="12" r="9"></circle><path d="M12 8v5M12 16h.01"></path></svg>
                  <div>Space is limited. Registration confirms your spot but does not guarantee entry after capacity is reached.</div>
                </div>
                <AgentCard
                  label="Hosted by"
                  firstName={projectdata?.agent?.firstName}
                  lastName={projectdata?.agent?.lastName}
                  phone={projectdata?.agent?.agentContact?.cContact?.phone}
                  email={projectdata?.agent?.primaryEmail}
                />
              </div>
            </div>
            <div className="rs-col">
              <Formik
                  enableReinitialize={true}
                  initialValues={{
                    projectEventInviteGuId: invitedata.projectEventInviteId,
                    id: invitedata.id,
                    projectId:invitedata.projectId,
                    projectName: invitedata.projectName,
                    name:  (this.state && this.state.name) || "",
                    phoneNo: (this.state && this.state.phoneNo) || "",
                    email:(this.state && this.state.email) || "",
                    //eventSlot:'',
                    isRealator: false,
                    
                  }}
                  validationSchema={Yup.object().shape({
                    name: Yup.string().required("This is Required"),
                    //eventSlot: Yup.string().required("This is Required"),
                    email: Yup.string().required("This is Required"),
                    phoneNo: Yup.string()
                      .test("phone", "Enter a valid phone number", (value) => (value || "").replace(/\D/g, "").length >= 10)
                      .required("This is Required")
                  })}

                 onSubmit={this.handleSubmit}

                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form className="rs-card-form">
                      {formVisible ? (
                        <>
                          <div>
                            <h2>Reserve your spot</h2>
                            <p className="lead">We&apos;ll send your confirmation and any updates to the details below.</p>
                          </div>
                          <label className="rs-field">
                            Name *
                            <Field name="name" type="text" className={"rs-input" + (errors.name && touched.name ? " is-invalid" : "")} />
                            <ErrorMessage name="name" component="div" className="rs-error" />
                          </label>
                          <div className="rs-grid-2">
                            <label className="rs-field">
                              Email *
                              <Field name="email" type="email" autoComplete="email" className={"rs-input" + (errors.email && touched.email ? " is-invalid" : "")} />
                              <ErrorMessage name="email" component="div" className="rs-error" />
                            </label>
                            <PhoneInputField
                              label="Phone"
                              name="phoneNo"
                              value={values.phoneNo || ""}
                              setFieldValue={setFieldValue}
                              error={errors.phoneNo}
                              touched={touched.phoneNo}
                              country="ca"
                              required
                            />
                          </div>
                          <fieldset className="rs-choices">
                            <legend>Are you a REALTOR?</legend>
                            <div className="rs-choice-row">
                              <label className="rs-choice"><Field type="radio" name="isRealator" value="true" />Yes</label>
                              <label className="rs-choice"><Field type="radio" name="isRealator" value="false" />No</label>
                            </div>
                          </fieldset>
                          <p className="rs-consent">By registering, you agree that {projectdata?.agent?.firstName} {projectdata?.agent?.lastName} may contact you about this project and similar homes. You can unsubscribe at any time.</p>
                          <button type="submit" className="rs-submit">Register for event</button>
                        </>
                      ) : (
                        <div>
                          <h2>Thank you</h2>
                          <p className="lead">{thankYouMessage}</p>
                        </div>
                      )}
                    </Form>
                  )}
              </Formik>
            </div>
          </div>
          <PublicFooter />
        </div>
          ):(
            <div className="rs-page">
              <PublicHeader logoSrc={logo} />
              <div className="rs-empty"><h2>loading...</h2></div>
              <PublicFooter />
            </div>
          )}
    </React.Fragment>
  )
}
}
ProjectInviteUser.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
}

const mapStateToProps = ({ Project }) => (
  {
   
    loading:Project.loading

  })
const mapDispatchToProps = dispatch => ({
 


});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ProjectInviteUser));


